<template>
    <div class="home-wrap">
        <div class="home-header-wrap">
            <v-banner></v-banner>
        </div>
        <div class="home-content-wrap">
            <!--左侧上方菜单-->
            <div class="left-nav-wrap">
                <div class="top-nav-wrap">
                    <!--空间预约 & 我的-->
                    <div class="nav-content-wrap">
                        <div v-if="['/main/home', '/main/layout'].indexOf($route.path) > -1" class="nav-item-wrap medium"
                            @click="changeRouter(1)">
                            {{ $t('tab.orders') }}
                        </div>
                        <div v-if="$route.path.indexOf('my') > -1" class="nav-item-wrap medium" @click="changeRouter(2)">
                            {{ $t('tab.query') }}
                        </div>
                    </div>
                </div>
                <div class="left-nav-content-wrap">
                    <!--空间预约首页的筛选条件-->
                    <template v-if="['/main/home', '/main/layout'].indexOf($route.path) > -1">
                        <div class="space-selected-wrap">
                            <div class="selected-content-wrap">
                                <div class="selected-item-wrap" v-if="systemInfo.specialRoomResList.length > 1">
                                    <div class="selected-title-wrap regular">{{ $t('home.specialSpace') }}</div>
                                    <div class="special">
                                        <el-button size="small" @click="selectSpecialSpace(index, item)"
                                            :type="specialRoomResIndex == index ? 'primary' : ''"
                                            v-for="(item, index) in systemInfo.specialRoomResList" :key="index">
                                            {{ $i18n.locale == 'zh' ? item.name : item.ename }}
                                        </el-button>
                                    </div>
                                </div>
                                <div class="selected-item-wrap">
                                    <div class="selected-title-wrap regular">{{ $t('home.selectTitle1') }}</div>
                                    <el-select v-model="params.venueId" :placeholder="$t('home.selectTitle1')"
                                        @change="(event) => changeParam('venuse')">
                                        <el-option v-for="item in buildList" :key="item.id"
                                            :label="$i18n.locale == 'zh' ? item.name : item.nameE" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="selected-item-wrap">
                                    <div class="selected-title-wrap regular">{{ $t('home.selectTitle2') }}</div>
                                    <el-select v-model="params.floorId" :placeholder="$t('home.selectTitle2')"
                                        @change="(event) => changeParam('type')">
                                        <el-option v-for=" item in getFloorListData() " :key="item.value"
                                            :label="$i18n.locale == 'zh' ? item.text : item.textE" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="selected-item-wrap">
                                    <div class="selected-title-wrap regular">{{ $t('home.selectTitle3') }}</div>
                                    <div class="myCalendar">
                                        <div class="day" v-for="( day, index ) in  dateList " @click="selectDateFun(day)">
                                            <div>{{ day.week }}</div>
                                            <div
                                                :class="{ disable: !day.status, check: day.date == selectDate.substring(8, selectDate.length) }">
                                                {{
                                                    day.date }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="selected-item-wrap">
                                    <div v-show="dateType == 0">
                                        <div class="selected-title-wrap regular">{{ $t('home.selectTitle4') }}</div>
                                        <div class="timeContainer">
                                            <el-time-picker v-model="params.startTimeText" :picker-options="{
                                                selectableRange: startTimeMinLimit + ' - ' + endTimeMaxLimit
                                            }
                                                " placeholder="请选择开始时间" format="HH:mm" @change="getEndTimeArray"
                                                :editable="false" :clearable="false">
                                            </el-time-picker>
                                            <el-select v-model="params.endTimeText"
                                                :placeholder="$t('home.endTimePlaceHolder')"
                                                @change="(event) => changeParam('time')">
                                                <el-option v-for=" item  in  endTimeArray " :key="item[1]" :label="item[1]"
                                                    :value="item[0]">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                    <div v-show="dateType == 1">
                                        <div class="select-box">
                                            <el-button size="small" class="select-box-btn"
                                                :type="params.amPm == item.value ? 'primary' : ''" :disabled="item.disabled"
                                                v-for="item in fixDateList" :key="item.value"
                                                @click="handlerSelectTime(item)">{{ item.text }}</el-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="selected-item-wrap">
                                    <div class="selected-title-wrap regular">{{ $t('home.selectTitle5') }}</div>
                                    <div class="otherOptions">
                                        <div>
                                            <el-switch @change="findRoomDurationFun" v-model="params.window" active-color="#409eff"></el-switch>
                                            <span>{{ $t('home.window') }}</span>
                                        </div>
                                        <div>
                                            <el-switch @change="findRoomDurationFun" v-model="params.power" active-color="#409eff"></el-switch>
                                            <span>{{ $t('home.power') }}</span>
                                        </div>
                                        <!-- <div>
                                            <el-switch v-model="params.roomType" active-color="#409eff"></el-switch>
                                            <span>{{ $t('home.roomType') }}</span>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="submit">
                                    <button @click="findRoomDurationFun">{{ $t('home.search') }}</button>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!--我的预约下面的三个菜单-->
                    <template v-if="$route.path.indexOf('my') > -1">
                        <div class="space-selected-wrap">
                            <div class="table-wrap">
                                <div class="table-item-wrap" :class="{ 'table-active': type == 0 }" @click="getRecords(0)">
                                    <div class="iconfont">&#xe61a;</div>
                                    <div class="table-word regular">{{ $t('my.tab1') }}</div>
                                </div>
                                <div class="table-item-wrap" :class="{ 'table-active': type == 1 }" @click="getRecords(1)">
                                    <div class="iconfont">&#xe61a;</div>
                                    <div class="table-word regular">{{ $t('my.tab2') }}</div>
                                </div>
                                <div class="table-item-wrap" :class="{ 'table-active': type == 2 }" @click="getRecords(2)">
                                    <div class="iconfont">&#xe69f;</div>
                                    <div class="table-word regular">{{ $t('my.tab3') }}</div>
                                </div>
                                <div class="table-item-wrap" :class="{ 'table-active': type == 3 }" @click="getRecords(3)" v-if="Boolean(vueConfig.doorLog)">
                                    <div class="iconfont">&#xe69f;</div>
                                    <div class="table-word regular">{{ $t('my.tab4') }}</div>
                                </div>
                            </div>
                            <div class="table-notice-wrap"></div>
                        </div>

                    </template>
                </div>
            </div>
            <!--左侧上方菜单-->
            <div class="home-mid-wrap">
                <keep-alive>
                    <router-view v-if="$route.meta.keepAlive" ref="child" />
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive" ref="child" />
            </div>
        </div>
        <!-- 激活码弹窗 -->
        <el-dialog class="active-tip-box" :visible.sync="this.showService" width="450px" :title="$t('login.server')"
            :close-on-click-modal="true" :show-close="false" center>
            <div class="body-wrap">
                <div class="verify-code-div">
                    <div class="titleName typeUse">
                        <div class="line"></div>
                        <div>{{ $t('service.title1') }}</div>
                        <div class="line"></div>
                    </div>
                    <div class="contactContainer">
                        <div class="contactItemC">
                            <div class="name">{{ $t('service.program') }}</div>
                            <div class="contactItem">
                                <img src="@/assets/images/wxkf.jpg" />
                            </div>
                        </div>
                        <div class="contactItemC">
                            <div class="name">{{ $t('service.wechat') }}</div>
                            <div class="contactItem">
                                <img src="@/assets/images/公众号.png" />
                            </div>
                        </div>
                    </div>
                    <div class="iknow" @click="showService = false">{{ $t('IKnow') }}</div>
                </div>
            </div>
        </el-dialog>

        <!-- 公告配置 -->
        <el-drawer
          title="温馨提示"
          :visible.sync="showNotice"
          direction="ltr"
        >
          <div class="readInfo">
            <div v-html="systemInfo.readText" class="content"></div>
          </div>
        </el-drawer>
    </div>
</template>

<script>
import banner from '@/components/banner.vue'
import { getBuildingFloorDate, getEndTimesFilter } from '../api/index'
import calendar from '../components/calendar/index.vue'
import utils from '@/lib/utils'
export default {
    components: {
        vBanner: banner,
        vCalendar: calendar
    },
    data() {
        return {
          showNotice: false,
            weeks: [this.$t('home.Sunday'), this.$t('home.Monday'), this.$t('home.Tuesday'), this.$t('home.Wednesday'), this.$t('home.Thursday'), this.$t('home.Friday'), this.$t('home.Saturday'),],
            selectTime: '',
            buildList: [],
            floorList: [],
            dateList: [],
            showService: false,
            selectDate: '',
            dateIndex: 0,
            params: {
                venueId: '',//场馆Id
                floorId: 0,
                startTimeText: new Date(),
                endTimeText: '',
                power: false,
                roomType: false,
                window: false,
                minMinutes: 1,
                amPm: 0, //0不限制 1上午 2下午
            },
            type: 1,
            startTimeMinLimit: "", //开始时间最小限制
            endTimeMaxLimit: '', //开始时间最大限制
            endTimeArray: [],
            dateType: 0, // 切换时间筛选，0默认选择时长，1是固定时长
            systemInfo: JSON.parse(sessionStorageProxy.getItem('systemInfo')),
            specialRoomResIndex: 0,
            vueConfig: JSON.parse(sessionStorageProxy.getItem('vueConfig')),
            defaultTime: ''
        }
    },
    computed: {
        // 切换是动态变化
        fixDateList() {
            return [
                { text: this.$t('home.selectDateTabsAll'), value: 0 },
                { text: this.$t('home.selectDateTabsAm'), value: 1, disabled: new Date().getHours() > 13 },
                { text: this.$t('home.selectDateTabsPm'), value: 2 },
            ]
        },
    },
    methods: {
        // 特殊空间类型选择
        selectSpecialSpace(index, item) {
            this.specialRoomResIndex = index
            this.dateType = 0
            this.params.roomType = false
            if (item.markMode && item.roomType == 'NORMAL') { //  固定时段空间
                this.dateType = 1 // 设置类型为固定时间
                this.params.amPm = 0
            } else {
                if (item.roomType == 'HOUR24') this.params.roomType = true
            }
            this.findRoomDurationFun()
        },
        getStartTimes: function () {

        },
        getEndTimes: function () {

        },
        getFloorListData: function () {
            let floorList = [{ text: this.$t('common.allFloor'), textE: this.$t('common.allFloor'), value: 0 }]
            return [...floorList, ...this.buildList.length > 0 ? this.buildList.filter((item, index) => { return item.id === this.params.venueId })[0].floors.map((item) => { return { text: item.name, textE: item.nameE, value: item.id } }) : 0]
        },
        //路由切换
        changeRouter(active) {
            this.active = active;
            if (active == 1) {
                this.$router.push({ path: "/main/home" })
            } else {
                this.$router.push({ path: "/main/my" })
            }
        },
        getBuildingFloorDateFun: function () {
            getBuildingFloorDate().then(res => {
                if (res.data.status) {
                    const { buildSeTime } = this.systemInfo
                    this.buildList = res.data.data.buildings.map(item => {
                      if (item.seTime) {
                        return item
                      } else {
                        return { ...item, seTime: buildSeTime[item.id].seTime  }
                      }
                    })
                    this.customDates = res.data.data.dates


                    if (this.params.venueId == '') {
                        this.params.venueId = this.buildList[0].id
                    }
                          
                    // 判断当前时间是否闭馆，闭馆默认进入下一天
                    let current = this.buildList.find(item => item.id == this.params.venueId)
                    if (utils.hhmmToMinute('now') >= utils.hhmmToMinute(current.seTime.split('_')[1])) {
                      // 初始化日期
                      this.getDates(res.data.data.dates, false)
                      // 获取当前可用的第一个index
                      let index = this.dateList.findIndex(item => item.status)

                      for (index = index+1; index < this.dateList.length; index++) {
                        let item = this.dateList[index]
                        
                        if (item.status) {
                          this.selectDateFun(item,index)
                          return
                        }
                      }

                    } else {
                      this.getEndTimeArray()
                      this.initTimeLimit()
                      this.getDates(res.data.data.dates)
                    }
                    

                } else {
                    this.buildList = []
                }
            }).catch(err => {
                console.log("场馆获取失败", err)
                this.buildList = []
            })
        },
        //切换筛选条件
        changeParam: function (e, fileds) {
            if (e == 'venuse') {
                this.params.floorId = 0

                // 初始化时间
                this.dateIndex = 0
                this.getDates(this.customDates, false)

                // 判断当前时间是否闭馆，闭馆默认进入下一天
                let current = this.buildList.find(item => item.id == this.params.venueId)
                if (utils.hhmmToMinute('now') >= utils.hhmmToMinute(current.seTime.split('_')[1])) {

                  // 获取当前可用的第一个index
                  let index = this.dateList.findIndex(item => item.status)

                  for (index = index+1; index < this.dateList.length; index++) {
                    let item = this.dateList[index]
                    
                    if (item.status) {
                      this.selectDateFun(item,index)
                      return
                    }
                  }

                } else {
                  let index = this.dateList.findIndex(item => item.status)
                  this.selectDateFun(this.dateList[index], index)
                }

            } else if (e == 'time') {
              // 先选结束时间默认设置开始时间
              let systemInfo = JSON.parse(sessionStorageProxy.getItem('systemInfo'))
              let buildSeTime = systemInfo.buildSeTime[this.params.venueId]
              let nowDate = new Date()

              nowDate.setHours(buildSeTime.openTimeStr.split(":")[0])
              nowDate.setMinutes(buildSeTime.openTimeStr.split(":")[1])

              if (!this.params.startTimeText) this.params.startTimeText = nowDate
            }
            // this.$nextTick(() => this.findRoomDurationFun() )
        },
        // 固定时间
        handleTabsClick(val) {
            this.params.amPm = 0
        },
        // 固定时间选择
        handlerSelectTime({ value, disabled }) {
            if (disabled) return
            this.params.amPm = value
            this.findRoomDurationFun()
        },
        //调用子路由方法查询
        findRoomDurationFun(ignore = false) {
            if (this.$route.name === 'home' || ignore) {
                if (this.$route.name == 'layout') {
                    this.$router.push({ path: '/main/home' })
                }
                let params = {}
                Object.assign(params, this.params, { selectDate: this.selectDate })
                
                let begin = ''
                
                if (params.startTimeText === 0) {
                  begin = -1
                } else {
                  begin = params.startTimeText == null || params.startTimeText == "" ? utils.hhmmToMinute('now') : this.hhmmToMinute(params.startTimeText.getHours() + ':' + params.startTimeText.getMinutes())
                  // let begin = params.startTimeText == null || params.startTimeText == "" ? utils.hhmmToMinute('now') : this.hhmmToMinute(params.startTimeText.getHours() + ':' + params.startTimeText.getMinutes())
                }
                let end = parseInt(params.endTimeText == '' ? 0 : params.endTimeText)
                params.begin = begin;
                params.end = end;

                sessionStorageProxy.setItem('queryParam', JSON.stringify(params))
                
                this.$nextTick(() => {
                    this.$refs.child.findRoomDurationFun({ ...params, dateType: this.dateType }, this.selectDate, 1)
                })
            }
        },
        hhmmToMinute: function (hhmm) {
            var arr = hhmm.split(":");
            return Number(arr[0]) * 60 + Number(arr[1]);
        },
        //调用子路由方法查询
        getRecords(type = 0) {
            this.type = type
            this.$nextTick(() => {
                this.$refs.child.getDataList(type)
            })
        },
        //选择日期
        selectDateFun: function (item, index) {
            if (item.status) {
                this.dateIndex = index
                this.selectDate = item.value
                let nowDate = utils.formDate1()
                if (nowDate != item.value) { //如果当前选择时间不是今天，把开始时间设置成开馆时间
                    let systemInfo = JSON.parse(sessionStorageProxy.getItem('systemInfo'))
                    let buildSeTime = systemInfo.buildSeTime[this.params.venueId]
                    let nowDate = new Date()
                    nowDate.setHours(buildSeTime.openTimeStr.split(":")[0])
                    nowDate.setMinutes(buildSeTime.openTimeStr.split(":")[1])
                    this.params.startTimeText = 0
                    // this.params.startTimeText = nowDate
                } else { //如果是今天
                    this.initDateTime()
                }
                this.initTimeLimit()
                this.getEndTimeArray()
                this.$nextTick(() => {
                  this.params.endTimeText = ''
                  this.findRoomDurationFun()
                } )
            }
        },
        //格式化日期格式
        getDates(array, flag = true) {
            if (array.length == 0) {
                alert('当前没有开放日期,请联系管理员');
                this.dates = []
            }
            let now = new Date()
            let set = new Set([...this.createdDateArray(array[0]), ...array])
            let dates = Array.from(set).map((item, i) => {
                let date = new Date(item)
                let index = array.indexOf(item);
                if (this.dateIndex == 0) {
                    if (index != -1 && this.dateIndex == -1) this.dateIndex = i;//设置可选日期第一天座位默认日期
                    if (index != -1 && now.getDate() == date.getDate()) {
                        this.dateIndex = i
                    }
                }
                return {
                    status: index != -1, //是否可预约  false  不可预约  true  可预约
                    week: this.weeks[date.getDay()],
                    date: date.getDate(),
                    value: this.formDate(item)
                }
            })
            let param = JSON.parse(sessionStorageProxy.getItem('queryParam'))
            if (param != null && flag) {
                this.selectDate = param.selectDate
            } else {
                this.selectDate = utils.formDate1()
            }
            this.dateList = dates

            const [item] = this.systemInfo.specialRoomResList
            // 按个时间段的初始化请求
            flag && this.selectSpecialSpace(0, item)
        },
        //生成虚拟的日期数组，7天
        createdDateArray(star, step = -2, list = []) {
            let day = new Date(star).getDay()
            if (day <= 3 && day != 0) step = (day - 1) * -1;
            while (list.length < 7) {
                list.push(this.formDate(new Date().getTime() + step++ * 1000 * 60 * 60 * 24))
            }
            return list;
        },
        //日期格式化
        formDate(date = new Date(), type = 1) {
            date = new Date(date)
            let year = date.getFullYear()
            let month =
                date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
            let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
            let houre = date.getHours()
            let minutes = date.getMinutes()
            let seconds = date.getSeconds()
            switch (type) {
                case 1:
                    return `${year}-${month}-${day}`
                case 2:
                    return `${year}-${month}-${day} ${houre}:${minutes}:${seconds}`
            }
        },
        //初始化时间限制
        initTimeLimit: function (callback) {
            let systemInfo = JSON.parse(sessionStorageProxy.getItem('systemInfo'))
            let buildSeTime = systemInfo.buildSeTime[this.params.venueId]
            this.startTimeMinLimit = buildSeTime.openTimeStr + ":00"
            
            // 设置默认回显
            this.defaultTime = '2024-01-01 ' + this.startTimeMinLimit

            this.endTimeMaxLimit = buildSeTime.closeTimeStr + ":00"
        },
        initDateTime: function () {
            let nowDate = new Date()
            let systemInfo = JSON.parse(sessionStorageProxy.getItem('systemInfo'))
            let buildSeTime = systemInfo.buildSeTime[this.params.venueId]
            const nowMinutes = utils.hhmmToMinute('now')
            if (nowMinutes < buildSeTime.openTime) { //如果当前时间小于开馆时间 设置成开馆时间
                nowDate.setHours(buildSeTime.openTimeStr.split(":")[0])
                nowDate.setMinutes(buildSeTime.openTimeStr.split(":")[1])
                this.params.startTimeText = nowDate
            } else if (nowMinutes > buildSeTime.closeTime) { //如果当前时间大于开馆时间 设置成闭馆时间
                console.log(buildSeTime.closeTimeStr.split(":")[0])
                console.log(buildSeTime.closeTimeStr.split(":")[1])
                nowDate.setHours(buildSeTime.closeTimeStr.split(":")[0])
                nowDate.setMinutes(buildSeTime.closeTimeStr.split(":")[1])
                console.log(nowDate)
                this.params.startTimeText = nowDate
            } else {
                this.params.startTimeText = nowDate
            }
        },
        //获取结束时间集合
        getEndTimeArray: function () {

          // 处理开始时间设置为-1
          let dateStr = utils.formDate1(), nowDate = new Date()
          if (dateStr != this.selectDate) { //如果当前选择时间不是今天，把开始时间设置成开馆时间
              let systemInfo = JSON.parse(sessionStorageProxy.getItem('systemInfo'))
              let buildSeTime = systemInfo.buildSeTime[this.params.venueId]
              nowDate.setHours(buildSeTime.openTimeStr.split(":")[0])
              nowDate.setMinutes(buildSeTime.openTimeStr.split(":")[1])
            }

            getEndTimesFilter(this.params.venueId, utils.hhmmToMinute(nowDate.getHours() + ':' + nowDate.getMinutes())).then((res) => {
                if (res.data.status) {
                    this.endTimeArray = res.data.data
                }
            })
        }
    },
    watch: {
        $route: function (v1, v2) {
            if (v1.name === 'home') { //从布局页面返回
                if (v2.name === 'layout') {
                    let queryParam = JSON.parse(sessionStorageProxy.getItem('queryParam'))
                    if (queryParam != null) {
                        this.params.venueId = queryParam.venueId
                        this.params.floorId = queryParam.floorId
                        this.params.power = queryParam.power
                        this.params.roomType = queryParam.roomType
                        this.params.windows = queryParam.windows
                        if (queryParam.starTimeText != '' && queryParam.starTimeText != null) {
                            let now = new Date()
                            // 使用 Date.parse() 将字符串解析为毫秒数
                            const milliseconds = Date.parse(queryParam.starTimeText);
                            // 使用 new Date() 将毫秒数转换为 Date 对象
                            const dateObject = new Date(milliseconds);
                            now.setHours(dateObject.getHours())
                            now.setMinutes(dateObject.getMinutes())
                            this.params.startTimeText = now
                        }
                        if (queryParam.endTimeText != '' && queryParam.endTimeText != null) {
                            this.params.endTimeText = queryParam.endTimeText
                        }
                        this.selectDate = queryParam.selectDate
                    }
                }
                this.getBuildingFloorDateFun()
            }
            if (v1.name === 'my') {
                this.getRecords()
            }
        },
        '$i18n.locale': {
            deep: true,
            handler: function (v1) {
                this.weeks = [this.$t('home.Sunday'), this.$t('home.Monday'), this.$t('home.Tuesday'), this.$t('home.Wednesday'), this.$t('home.Thursday'), this.$t('home.Friday'), this.$t('home.Saturday')]
                this.getBuildingFloorDateFun()
            }
        }
    },
    created() {
        if (this.$route.name === 'my') {
            this.getRecords()
        } else {
            let queryParam = JSON.parse(sessionStorageProxy.getItem('queryParam'))
            if (queryParam == null) {
                this.selectDate = utils.formDate1()
            } else {
                this.params.venueId = queryParam.venueId
                this.params.floorId = queryParam.floorId
                this.params.power = queryParam.power
                this.params.roomType = queryParam.roomType

                this.params.windows = queryParam.windows
                if (queryParam.starTimeText != '' && queryParam.starTimeText != null) {
                    let now = new Date()
                    // 使用 Date.parse() 将字符串解析为毫秒数
                    const milliseconds = Date.parse(queryParam.starTimeText);
                    // 使用 new Date() 将毫秒数转换为 Date 对象
                    const dateObject = new Date(milliseconds);
                    now.setHours(dateObject.getHours())
                    now.setMinutes(dateObject.getMinutes())
                    this.params.startTimeText = now
                } else {
                    this.initDateTime()
                }
                if (queryParam.endTimeText != '' && queryParam.endTimeText != null) {
                    let now = new Date()
                    // 使用 Date.parse() 将字符串解析为毫秒数
                    const milliseconds = Date.parse(queryParam.endTimeText);
                    // 使用 new Date() 将毫秒数转换为 Date 对象
                    const dateObject = new Date(milliseconds);
                    now.setHours(dateObject.getHours())
                    now.setMinutes(dateObject.getMinutes())
                    this.params.endTimeText = dateObject.getHours() * 60 + dateObject.getMinutes()
                }
                this.selectDate = queryParam.selectDate
            }
            this.getBuildingFloorDateFun()
        }
    },
    mounted() {
      if (this.systemInfo.readType == 1) { //首次登录显示
        let firstLogin = localStorageProxy.getItem("firstLogin") //是否第一次登录
        if (!firstLogin) { //如果是第一次登录
          this.showNotice = true
          localStorageProxy.setItem("firstLogin", false)
        }
      } else if (this.systemInfo.readType == 2) {
        let showNotice = sessionStorageProxy.getItem("showNotice") //是否显示通知
        if (showNotice == null) { //如果需要弹出许可
          this.showNotice = true
          sessionStorageProxy.setItem("showNotice", true)
        }
      } else if (this.systemInfo.readType == 3) {
        const languageType = localStorageProxy.getItem("languageType") || "zh"
        // 对比
        if (languageType == 'zh') {
          let notice = localStorageProxy.getItem("readText")
          this.showNotice = !(notice == this.systemInfo.readText)
        } else {
          let noticeE = localStorageProxy.getItem("readTextE")
          this.showNotice = !(noticeE == this.systemInfo.readTextE)
        }
        // 储存
        localStorageProxy.setItem('readText', this.systemInfo.readText)
        localStorageProxy.setItem('readTextE', this.systemInfo.readTextE)
      }
    },
    activated() {
        this.active = this.$route.path == '/main/my' ? 2 : 1
    }
}
</script>

<style lang="less" scoped>
.home-wrap {
    //background: #f7f8fa;
    background: #dee0e3;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;

    &/deep/.el-dialog__title {
        font-size: 1.2rem;
    }

    .noticeList {
        &/deep/.el-dialog__title {
            font-size: 1.2rem;
        }

        &/deep/.el-collapse-item__header {
            font-size: 1.2rem;
        }
    }

    .noticeModal {
        width: 100%;
        height: 40vh;
        overflow-y: scroll;

        &/deep/ * {
            white-space: unset !important;
            color: inherit;
            font-size: inherit;
        }

        &/deep/p {
            font-size: 1rem;
        }
    }

    .closeNotice {
        background-color: #1682ff;
        width: 20%;
        color: white;
        text-align: center;
        padding-top: 8px;
        padding-bottom: 8px;
        border-radius: 5px;
        margin: 0 auto;
        margin-top: 50px;
        cursor: pointer;
    }

    .home-header-wrap {
        height: 80px;
    }

    .home-content-wrap {
        margin: 20px 30px 20px;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;

        .left-nav-wrap {
            height: 100%;
            width: 348px;
            min-width: 348px;
            display: flex;
            flex-direction: column;
            border-radius: 5px;

            .top-nav-wrap {
                width: 100%;
                height: 68px;
                position: relative;
                background: white;

                .line-wrap {
                    width: 74px;
                    height: 3px;
                    position: absolute;
                    bottom: 0px;
                    left: 50px;
                    background: #409eff;
                    transition: all 0.5s;
                }

                .nav-1 {
                    left: 50px;
                }

                .nav-2 {
                    left: 225px;
                }
            }

            .nav-content-wrap {
                display: flex;
                height: 60px;
                padding: 0 22px;
                justify-content: space-between;

                .nav-item-wrap {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 68px;
                    font-size: 20px;
                    font-weight: 400;
                    color: #12131a;
                    cursor: pointer;
                    user-select: none;
                    transition: all 0.5s;
                    font-size: 23px;

                    .iconfont {
                        font-size: 26px;
                        margin-right: 5px;
                    }
                }

                .note {
                    line-height: 68px;
                    color: #0f6ef2;
                    cursor: pointer;

                    i {
                        margin-right: 5px;
                    }
                }
            }

            .left-nav-content-wrap {
                background: white;
                flex: 1;
                padding: 0px 20px;
            }
        }

        .home-mid-wrap {
            flex: 1;
            height: 100%;
            margin-left: 11px;
        }
    }

    .space-selected-wrap {
        height: 100%;
        display: flex;
        flex-direction: column;

        &.notice-list-wrap {
            margin-top: 20px;
        }

        .table-wrap {
            margin-top: 20px;

            &.notice-wrap {
                margin-top: unset !important;
            }

            i {
                font-size: 20px;
            }
        }

        .table-item-wrap {
            margin-top: 10px;
            display: flex;
            align-items: center;
            width: 100%;
            min-height: 51px;
            cursor: pointer;
            border-radius: 7px 7px 7px 7px;
            padding: 15px;

            .iconfont {
                font-size: 22px;
                color: #454859;
            }

            .table-word {
                margin-left: 10px;
                font-size: 19px;
                font-weight: 400;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }

        .table-active {
            background: #f1f1f1;

            .iconfont,
            .table-word {
                color: #409eff;
            }

            i {
                color: #409eff;
            }
        }

        .selected-item-wrap {
            margin-top: 16px;

            &/deep/.el-input__prefix {
                display: none;
            }

            &/deep/.el-input__inner {
                padding-left: 20px;
            }

            .myCalendar {
                background: #feffff;
                border: 1px solid #dcdfe6;
                border-radius: 4px 4px 4px 4px;
                opacity: 1;
                border: 1px solid #efefef;
                margin-top: 15px;
                display: flex;
                padding: 10px;
                padding-bottom: 20px;

                .day {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    div:first-child {
                        height: 50px;
                        line-height: 50px;
                        font-size: 16px;

                    }

                    div:last-child {
                        height: 30px;
                        line-height: 30px;
                        font-size: 14px;
                        width: 30px;
                        text-align: center !important;
                        margin-top: 5px;

                        &.disable {
                            color: #c0c4cc;
                        }

                        &.check {
                            background-color: #409EFF;
                            border-radius: 50%;
                            color: white;
                        }
                    }
                }
            }

            div:first-child {
                text-align: left
            }

            .selected-title-wrap {
                font-size: 18px;
                color: #454859;

            }

            .el-date-editor--timerange.el-input__inner {
                width: 310px;
            }

            .el-date-editor .el-range-separator {
                width: 10%;
            }

            .otherOptions {
                margin-top: 10px;
                display: flex;
                flex-wrap: wrap;

                >div {
                    font-size: 15px;
                    display: flex;
                    margin-right: 20px;
                    margin-bottom: 10px;
                    align-items: center;
                    color: #606266;

                    span {
                        margin-left: 7px;
                    }
                }
            }

            .special {
                padding-top: 8px;
                display: flex;
                justify-content: space-between;

                .el-button--small {
                    border-radius: 6px;
                }
            }
        }

        .submit {
            button {
                width: 100%;
                height: 40px;
                background-color: #409eff;
                border: none;
                color: white;
                border-radius: 5px;
                font-size: 16px;
                letter-spacing: 1px;
                margin-top: 20px;
                cursor: pointer;
            }
        }

        .buttons-wrap {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0px 2px;
        }
    }

    .select-box {
        display: flex;
        justify-content: space-between;

        .select-box-item {
            width: 30%;
            line-height: 40px;
            color: #606266;
            font-size: 15px;
            background-color: #fff;
            border-radius: 7px;
            border: 1px solid #ccc;
            text-align: center !important;
            cursor: pointer;

            &.active {
                color: #FFF;
                background-color: #409EFF;
                border-color: #409EFF
            }

            &.disabled {
                cursor: no-drop
            }
        }

        .select-box-btn {
            min-width: 90px;
            border-radius: 7px;
        }
    }
}

//激活码弹窗

.body-wrap {
    margin: 0px 30px;
    height: 100%;
    position: relative;

    .titleName {
        color: #27489a;
        font-size: 20px;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        margin-bottom: 30px;
        align-items: center;

        &.typeUse {
            margin-top: 30px;
        }

        .line {
            height: 1px;
            background-color: #c7c4e3;
            width: 25%;
        }
    }

}

.home-nav {
    width: 90px;
    background: #ffffff;
    border: 1.30488px solid rgba(68, 135, 240, 0.6);
    box-sizing: border-box;
    border-radius: 18px;
    margin: 10px 0 0 38px;
    margin-right: 20px;
    padding-bottom: 9px;
    position: fixed;
    right: 0;
    top: 25%;
}

.nav-icon {
    text-align: center;
}

.nav-text {
    text-align: center;
}

.iknow {
    width: 100%;
    background-color: #3582fa;
    color: white;
    padding-top: 10px;
    padding-bottom: 11px;
    text-align: center;
    border-radius: 5px;
    margin: 0 auto;
    margin-top: 40px;
    margin-bottom: 10px;
}

.nav-wrap {
    width: 85px;
    height: 80px;
    padding-top: 11px;
    margin-top: 9px;
    position: relative;
    cursor: pointer;

    img {
        object-fit: cover;
    }
}
</style>
<style lang="less">
.selected-item-wrap {
    .el-input {
      width: 100%!important;
    }
    .el-select {
        margin-top: 9px;
        width: 100%;
        height: 43px;
        border-radius: 4px 4px 4px 4px;
    }

    .el-date-editor {
        margin-top: 9px;
        width: 100%;
        height: 43px;
        border-radius: 4px 4px 4px 4px;

        .el-range-separator {
            width: 10%;
        }
    }

    .el-calendar {
        width: 311px;
        height: 143px;
        background: #feffff;
        box-shadow: 0px 11px 16px 1px rgba(0, 0, 0, 0.08);
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #efefef;
        margin-top: 15px;

        .current {
            height: 36px;
            width: 34px;
        }

        .el-calendar-day {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
                font-family: "SCRegular";
                font-size: 13px;
                font-weight: 400;
            }
        }

        .el-calendar-day-disable span {
            color: #c0c4cc;
        }
    }

    .is-today {
        color: #333 !important;
    }

    .el-calendar-table td {
        border: none !important;
    }

    .el-calendar-table .el-calendar-day:hover {
        background-color: #f2f8fe;
        border-radius: 50%;
    }

    .el-calendar-table .el-calendar-day-disable:hover {
        background-color: white;
    }

    .is-selected .el-calendar-day:hover {
        background-color: #3997f5 !important;
        border-radius: 50%;
    }

    .is-selected {
        color: white !important;
        border-radius: 50%;
        background-color: #1989fa !important;
    }
}

.left-nav-content-wrap {
    .buttons-wrap {
        .el-button {
            height: 50px !important;
            font-family: "SCRegular";
            font-size: 18px;
            font-weight: 400;
            padding: 12px 12px;
            box-shadow: 0px 11px 16px 1px rgb(0 0 0 / 8%);
        }
    }
}

.readInfo {
  padding: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .title {
    font-size: 20px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    align-items: center;
  }

  .content {
    flex: 1;
    overflow: auto;
    margin-bottom: 30px;
    color: #494949cc;
    text-align: unset !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/main.vue